<script>
  import { asnavigate } from '../Utils/asnavigation.js';
  import {
    currentLocation,
    pathTrappe,
    dimLongueur,
    dimLargeur,
    sensOuverture,
    dimLongueurIdFiche,
    dimLargeurIdFiche,
    sensOuvertureIdFiche,
  } from '../stores.js';
  import { useNavigate } from 'svelte-navigator';
  import Modal, { getModal } from '../Components/Modal.svelte';
  import RangeSlider from 'svelte-range-slider-pips';
  export let idFiche;
  const navigate = useNavigate();

  function pageNext() {
    $dimLongueurIdFiche = 3;
    $dimLongueur = longeurValues;
    $dimLargeur = LargeurValues;
    let next = parseInt(idFiche) + 1;
    pathTrappe.add($currentLocation, [
      'dimLongueur',
      'dimLargeur',
      'dimLongueurIdFiche',
    ]);
    if (longeurValues[0] === LargeurValues[0]) {
      $sensOuverture = 'Sur un côté de ' + $dimLargeur + ' mm';
      $sensOuvertureIdFiche = 4;
      pathTrappe.add('/LayoutPage/' + next, [
        'sensOuverture',
        'sensOuvertureIdFiche',
      ]);
      next++;
    }
    navigate('/LayoutPage/' + next);
  }
  let longeurValues = [300];
  let LargeurValues = [300];
  function checkDimensions(e) {
    let returnOk = true;
    // console.log(e.detail.value);
    console.log(longeurValues);
    console.log(LargeurValues);
    if (longeurValues > 1000 && LargeurValues > 1200) {
      returnOk = false;
    }
    if (longeurValues > 1050 && LargeurValues > 1150) {
      returnOk = false;
    }
    if (longeurValues > 1100 && LargeurValues > 1100) {
      returnOk = false;
    }
    if (longeurValues > 1150 && LargeurValues > 1050) {
      returnOk = false;
    }
    if (longeurValues > 1200 && LargeurValues > 1000) {
      returnOk = false;
    }
    if (!returnOk) {
      getModal().open();
      longeurValues = [1000];
      LargeurValues = [1000];
      return false;
    }
    return true;
  }
  let selection;
  // Callback function provided to the `open` function, it receives the value given to the `close` function call, or `undefined` if the Modal was closed with escape or clicking the X, etc.
  function setSelection(res) {
    selection = res;
  }
</script>

<Modal>
  <h1 class="">Dimensions non disponibles</h1>
  <p>
    Nos trappes ont un format maximum de 1200 x 1200.<br />
    <button
      class="mt-3 mb-3 btn-modal"
      on:click="{() =>
        asphone(
          'second',
          setSelection,
          './statics/dimensions/etancheite_eau_air.png'
        )}"
    >
      <!-- on:click="{() => getModal('second').open(setSelection)}" -->
      Voir tous les formats
    </button>
  </p>
  <p style="font-weight:700">
    Important : nos trappes vide sanitaire s’intalle de manière verticale
  </p>
</Modal>

<Modal id="second">
  <!-- <img scr="http://localhost:5000/statics/test-img-dimensions.png" alt="test dim" /> -->
  <img
    src="./statics/dimensions/etancheite_eau_air.png"
    alt="test dim"
    style="width: 100%;
    max-width: 3000px;"
  />
</Modal>

<div
  class="as-range-slider relative flex flex-col min-w-0 break-words mb-6 w-full  shadow-lg rounded-lg  bg-white transition duration-300 transform group hover:shadow-xl"
  aria-label="View item"
  title="View item"
>
  <blockquote class="relative p-6 w-full">
    <h4 class="text-xl font-bold  mb-8">Longueur et largeur de votre trappe</h4>
    <div class="w-full grid grid-flow-col grid-cols-12 gap-4 align-bottom">
      <div class="col-span-9  text-left">
        <!-- https://simeydotme.github.io/svelte-range-slider-pips/ 
        Pipstep calculation to split by 4 :
            ((slider1Max - slider1Min) / slider1Step) / 4
            if result in not an integer, the slider will glitch -->

        <RangeSlider
          bind:values="{longeurValues}"
          float
          pips
          all="label"
          pipstep="{1200}"
          step="{10}"
          min="{200}"
          max="{1200}"
          on:stop="{(e) => {
            checkDimensions(e);
          }}"
        />

        <!-- <RangeSlider
        bind:values="{longeurValues}"
        float
        pips
        all="label"
        pipstep="{slider1Pipstep}"
        step="{slider1Step}"
        min="{200}"
        max="{slider1Max}"
        on:stop="{(e) => {
          checkDimensions(e);
        }}"
      /> -->
      </div>
      <div class="col-span-3  text-left mt-1 mb-8">
        <div class="flex flex-wrap items-stretch w-full mb-4 relative">
          <div class="flex -mr-px">
            <span
              class="flex items-center leading-normal bg-grey-lighter rounded rounded-r-none border border-r-0 border-grey-light px-3 whitespace-no-wrap text-grey-dark text-sm"
              style="border-color: #000;color: #000;">Longeur</span
            >
          </div>
          <input
            disabled
            value="{longeurValues}"
            id="dimLongeur"
            type="text"
            class="flex-shrink flex-grow flex-auto leading-normal w-px  border h-10 border-grey-light rounded rounded-r-none px-3 relative"
            placeholder="Longeur en mm"
            style="border-color: #000;color: #000;"
          />
          <div class="flex -mr-px">
            <span
              class="flex items-center leading-normal bg-grey-lighter rounded rounded-l-none border border-l-0 border-grey-light px-3 whitespace-no-wrap text-grey-dark text-sm"
              style="border-color: #000;color: #000;">mm</span
            >
          </div>
        </div>
      </div>
    </div>

    <div class="w-full grid grid-flow-col grid-cols-12 gap-4 align-bottom mb-8">
      <div class="col-span-9  text-left">
        <!-- https://simeydotme.github.io/svelte-range-slider-pips/ 
        Pipstep calculation to split by 4 :
            ((slider1Max - slider1Min) / slider1Step) / 4
            if result in not an integer, the slider will glitch -->

        <RangeSlider
          bind:values="{LargeurValues}"
          float
          pips
          all="label"
          pipstep="{1200}"
          step="{10}"
          min="{200}"
          max="{1200}"
          on:stop="{(e) => {
            checkDimensions(e);
          }}"
        />
      </div>
      <div class="col-span-3  text-left mt-1">
        <div class="flex flex-wrap items-stretch w-full mb-4 relative">
          <div class="flex -mr-px">
            <span
              class="flex items-center leading-normal bg-grey-lighter rounded rounded-r-none border border-r-0 border-grey-light px-3 whitespace-no-wrap text-grey-dark text-sm"
              style="border-color: #000;color: #000;">Largeur</span
            >
          </div>
          <input
            disabled
            value="{LargeurValues}"
            id="dimLongeur"
            type="text"
            class="flex-shrink flex-grow flex-auto leading-normal w-px  border h-10 border-grey-light rounded rounded-r-none px-3 relative"
            placeholder="Longeur en mm"
            style="border-color: #000;color: #000;"
          />
          <div class="flex -mr-px">
            <span
              class="flex items-center leading-normal bg-grey-lighter rounded rounded-l-none border border-l-0 border-grey-light px-3 whitespace-no-wrap text-grey-dark text-sm"
              style="border-color: #000;color: #000;">mm</span
            >
          </div>
        </div>
      </div>
    </div>

    <div class="w-full grid grid-flow-col grid-cols-12 gap-4 align-bottom">
      <div
        class="col-span-9  text-center text-sm mt-5"
        style="font-style:italic"
      >
        <p>
          Nos trappes ont un format maximum de 1200 x 1200.
          <a
            style="font-weight:bold;text-decoration:underline;cursor:pointer"
            on:click="{() =>
              asphone(
                'second',
                setSelection,
                './statics/dimensions/etancheite_eau_air.png'
              )}"
          >
            <!-- on:click="{() => getModal('second').open(setSelection)}" -->
            Voir tous les formats
          </a>
        </p>
      </div>

      <div class="col-span-3 text-right flex justify-end items-end pb-4">
        <button on:click="{() => pageNext()}" class="as-btn-rounded">
          valider
        </button>
      </div>
    </div>
  </blockquote>
</div>

<style>
  h1 {
    font-size: 20px;
    margin: 20px 0 10px;
  }
  .btn-modal {
    display: inline-block;
    border: 1px solid #000;
    border-radius: 5px;
    font-size: 0.8em;
    text-transform: uppercase;
    padding: 5px 10px;
    background-color: #0001;
    transition: all 500ms;
  }
  /* .btn-modal.block {
    display: block;
    margin: 0 auto;
  } */
  .btn-modal:hover {
    background-color: #fff;
    color: rgb(104, 104, 104);
    border: 1px solid rgb(104, 104, 104);
    transform: translateY('10px');
  }
</style>
